export default __webpack_public_path__ + "static/media/about.0f5f8abb.pdf";